<footer class="footer bg-light text-center text-lg-start" id="footer">
    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: #111f43;color: white;">
        Módulo de Tickets
    </div>
    <!-- Copyright -->
</footer>